import React from "react";
import ReactHtmlParser from 'react-html-parser';
// nodejs library that concatenates classes
import classNames from "classnames";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import descriptionStyle from "assets/jss/material-kit-pro-react/views/aboutUsSections/descriptionStyle.js";

import {data} from '../Sections/about-us-data';

const useStyles = makeStyles(descriptionStyle);


export default function SectionDescription() {
  const classes = useStyles();
  return (
    <div className={classNames(classes.aboutDescription, classes.textCenter)}>
      <GridContainer>
        <GridItem
          md={8}
          sm={8}
          className={classNames(classes.mrAuto, classes.mlAuto)}
        >
          <h5 className={classes.description}>
            {ReactHtmlParser(data.article.heading.subHeader)}
          </h5>
        </GridItem>
      </GridContainer>
    </div>
  );
}
